// AllKeys.status values (see allKeys.service.ts) - matched by exact lowercased status string.
// One color per stage of the key's lifecycle: teal while live, orange/amber while waiting on
// something, green once it's safely back in house, blue once it's closed out with the customer,
// red for lost.
export const KeyRegisterStatus = {
  live: { bg: '#e6fbfd', text: '#0091ae' },                // Teal - live/in use
  'awaiting receipt': { bg: '#fff7ed', text: '#ea580c' },  // Orange - waiting to receive from the customer
  'return requested': { bg: '#fffbeb', text: '#b45309' },  // Amber - return requested, not back yet
  returned: { bg: '#f0fdf4', text: '#16a34a' },            // Green - back in house
  terminated: { bg: '#eff6ff', text: '#2563eb' },          // Blue - returned to customer, closed out
  lost: { bg: '#fef2f2', text: '#dc2626' },                // Red
  'never received': { bg: '#f3f4f6', text: '#6b7280' },   // Slate - site terminated before this key ever arrived
}
